"use client";
import { createContext, useContext, useState } from "react";
import { RiMenu3Fill } from "react-icons/ri";
import { CgClose } from "react-icons/cg";
import { IoHomeOutline } from "react-icons/io5";
import { VscFolder, VscNewFolder } from "react-icons/vsc";
import { FaFont } from "react-icons/fa";
import { LuImage, LuImagePlus } from "react-icons/lu";
import { RiImageAddLine } from "react-icons/ri";
import { GrImage } from "react-icons/gr";
import { FaRegImages } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const SidebarContext = createContext();
export default function Sidebar({ children }) {
  const [expanded, setExpanded] = useState(true);

  return (
    <aside className="h-screen sticky z-60 top-0 left-0 hidden md:inline-block">
      <nav className="h-full flex flex-col bg-primary">
        <div className="p-4 pb-2 flex justify-between items-center">
          <img
            src="https://img.logoipsum.com/243.svg"
            className={`overflow-hidden transition-all ${
              expanded ? "w-32" : "w-0"
            }`}
            alt=""
          />
          <button
            onClick={() => setExpanded((curr) => !curr)}
            className="p-1.5 rounded-lg text-white text-22 font-bold"
          >
            {expanded ? <CgClose /> : <RiMenu3Fill />}
          </button>
        </div>

        <SidebarContext.Provider value={{ expanded }}>
          <ul className="flex-1 px-3 pt-5">
            <SidebarItem SidebarContext={SidebarContext} />
          </ul>
        </SidebarContext.Provider>
      </nav>
    </aside>
  );
}

export function SidebarItem({ SidebarContext }) {
  const { expanded } = useContext(SidebarContext);
  const navigate = useNavigate();
  const location = window.location.pathname;

  const sidebarMenus = [
    {
      sideIcon: (
        <IoHomeOutline className="group-hover:bg-gray-800 bg-transparent" />
      ),
      name: "Dashboard",
      url: "/dashboard",
    },
    {
      sideIcon: (
        <VscFolder className="group-hover:bg-gray-800 bg-transparent" />
      ),
      name: "Categories",
      url: "/categories",
    },
    {
      sideIcon: (
        <VscNewFolder className="group-hover:bg-gray-800 bg-transparent" />
      ),
      name: "Add Categories",
      url: "/add-categories",
    },
    {
      sideIcon: (
        <VscFolder className="group-hover:bg-gray-800 bg-transparent" />
      ),
      name: "Collections",
      url: "/collections",
    },
    {
      sideIcon: (
        <VscNewFolder className="group-hover:bg-gray-800 bg-transparent" />
      ),
      name: "Add Collections",
      url: "/add-collections",
    },
    {
      sideIcon: <LuImage className="group-hover:bg-gray-800 bg-transparent" />,
      name: "Wallpapers",
      url: "/images",
    },
    {
      sideIcon: (
        <LuImagePlus className="group-hover:bg-gray-800 bg-transparent" />
      ),
      name: "Add 4k Images",
      url: "/add-images",
    },
    {
      sideIcon: (
        <RiImageAddLine className="group-hover:bg-gray-800 bg-transparent" />
      ),
      name: "Add Multi 4k Images",
      url: "/add-multi-images",
    },
    {
      sideIcon: <GrImage className="group-hover:bg-gray-800 bg-transparent" />,
      name: "4D Parallax",
      url: "/parallax",
    },
    {
      sideIcon: <GrImage className="group-hover:bg-gray-800 bg-transparent" />,
      name: "Multi 4D Parallax",
      url: "/multi-parallax",
    },
    {
      sideIcon: <LuImagePlus className="group-hover:bg-gray-800 bg-transparent" />,
      name: "Live Clock",
      url: "/live-clock",
    },
    {
      sideIcon: <FaFont className="group-hover:bg-gray-800 bg-transparent" />,
      name: "Fonts",
      url: "/fonts",
    },
    {
      sideIcon: <GrImage className="group-hover:bg-gray-800 bg-transparent" />,
      name: "Live Wallpapers",
      url: "/wallpaper",
    },
    {
      sideIcon: (
        <FaRegImages className="group-hover:bg-gray-800 bg-transparent" />
      ),
      name: "Multi Live Wallpapers",
      url: "/multi-wallpaper",
    },
    // {
    //   sideIcon: <GrImage className="group-hover:bg-gray-800 bg-transparent" />,
    //   name: "3D Wallpapers",
    //   url: "/3d-wallpaper",
    // },
    // {
    //   sideIcon: (
    //     <FaRegImages className="group-hover:bg-gray-800 bg-transparent" />
    //   ),
    //   name: "Multi 3D Wallpapers",
    //   url: "/multi-3d-wallpaper",
    // },
    // {
    //   sideIcon: (
    //     <LuImagePlus className="group-hover:bg-gray-800 bg-transparent" />
    //   ),
    //   name: "Add HDR Images",
    //   url: "/add-hdr-images",
    // },
    // {
    //   sideIcon: (
    //     <RiImageAddLine className="group-hover:bg-gray-800 bg-transparent" />
    //   ),
    //   name: "Add Multi HDR Images",
    //   url: "/add-multi-hdr-images",
    // },
  ];

  return (
    <>
      {sidebarMenus.map((item, index) => (
        <li
          key={index}
          className={`
        relative flex items-center py-2 px-3 my-1 h-10 group
        font-medium rounded-md cursor-pointer hover:bg-gray-800 hover:text-white
        ${
          location.includes(item.url)
            ? "bg-gray-800 text-white"
            : " text-gray-400"
        }
    `}
          onClick={() => navigate(item.url)}
        >
          {item.sideIcon}
          <span
            className={`overflow-hidden group-hover:bg-gray-800 group-hover:text-white ${
              expanded ? "w-52 ml-3 " : "w-0"
            } ${
              location.includes(item.url)
                ? "bg-gray-800 text-white"
                : " text-gray-400"
            }`}
          >
            {item.name}
          </span>
        </li>
      ))}
    </>
  );
}
